import { Link } from "react-router-dom";
import { works } from "@/mocks/works";

export default function WorksSection() {
  const featured = works.filter((w) => Number(w.followers.replace("万", "")) >= 8).slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div>
            <span className="text-xs font-medium tracking-widest text-accent-600">热门作品</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">
              漫友都在追的漫画
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              每部漫画下方都有专属讨论区，随时找到同好一起聊剧情、猜结局。
            </p>
          </div>
          <Link
            to="/works"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-500"
          >
            全部作品 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((w) => (
            <Link
              key={w.id}
              to={`/post/${w.id}`}
              className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 shadow-sm hover:-translate-y-1 hover:shadow-md transition-all"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={w.cover}
                  alt={`${w.title}漫画封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded-full bg-primary-500 text-background-50 px-2.5 py-1 text-xs font-medium">
                  {w.status}
                </span>
                <span className="absolute right-2 top-2 rounded-full bg-foreground-950/70 text-background-50 px-2.5 py-1 text-xs backdrop-blur">
                  ★ {w.rating}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-950">{w.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">
                  {w.author} · {w.category} · {w.episodes}话
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs text-foreground-600">
                  <i className="ri-user-heart-line text-primary-500" />
                  <span>{w.followers} 同好</span>
                  <span className="ml-auto text-primary-600 group-hover:translate-x-1 transition-transform">
                    进讨论区 <i className="ri-arrow-right-s-line" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}